import React from "react";
import { useTranslation } from "lib/i18n/use-translation";
import { Button } from "components/ui";
import WoneLogo from "Assets/images/logo.svg";
import { ReactComponent as ChevronIcon } from "Assets/icon/icon-chevron.svg";
import styles from "./ReportReadyStep.module.scss";

export interface ReportReadyStepProps {
  firstName?: string | null;
  onStart: () => void;
}

const ReportReadyStep: React.FC<ReportReadyStepProps> = ({
  firstName,
  onStart,
}) => {
  const { t } = useTranslation(["assessment"]);

  return (
    <div className={styles.step} data-testid="report-ready-step">
      <img src={WoneLogo} alt="" className={styles.logo} />
      <h1 className={styles.heading}>
        {firstName
          ? t("assessment:report.ready.headingNamed", { name: firstName })
          : t("assessment:report.ready.heading")}
      </h1>
      <Button
        variant="enclosed-primary"
        monochromeColour="white"
        className={styles.start}
        onClick={onStart}
        icon={<ChevronIcon className={styles.chevron} aria-hidden="true" />}
        iconPosition="end"
        data-testid="report-start"
      >
        {t("assessment:report.ready.start")}
      </Button>
    </div>
  );
};

export default ReportReadyStep;
